import React from 'react'
import { ToastProvider } from './stores/ToastContext'
import Store from './Store'
import { getEnvironmentValue } from './utils/environmentConfig'

const enableDynatrace = () => {
  if (import.meta.env.MODE !== 'development') {
    if (typeof window.dtrum !== 'undefined' && window.dtrum && window.dtrum.enable) {
      window.dtrum.enable()
      // eslint-disable-next-line no-console
      console.log('Dynatrace enabled')
    } else {
      // eslint-disable-next-line no-console
      console.log('Dynatrace disabled')
    }
  } else {
    // eslint-disable-next-line no-console
    console.log('Dynatrace is not enabled in development mode')
  }
}

const loadDynatraceScriptAndEnable = () => {
  const scriptUrl = getEnvironmentValue('dynatraceUrl') || import.meta.env.VITE_DYNATRACE_JS_URL
  if (!scriptUrl) {
    // eslint-disable-next-line no-console
    console.log('Dynatrace script URL is not set for this environment.')
    return
  }

  const script = document.createElement('script')
  script.src = scriptUrl
  script.async = true
  script.type = 'text/javascript'

  // When the Dynatrace script loads, enable Dynatrace
  script.onload = () => {
    enableDynatrace()
  }
  script.onerror = () => {
    // eslint-disable-next-line no-console
    console.log('Failed to load Dynatrace script:')
  }

  document.head.appendChild(script)
}

loadDynatraceScriptAndEnable()

const App = () => {
  return (
    <ToastProvider>
      <Store />
    </ToastProvider>
  )
}

export default App
